import { Button } from "ant-design-vue";
import "./src/button.less"
const { Group, ...other } = Button;
const YwButton = {
  ...other,
  name: "YwButton",
  Group: {
    ...Group,
    name: "YwButtonGroup",
  },
};

YwButton.install = function (Vue) {
  Vue.component(YwButton.name, YwButton);
  Vue.component(YwButton.Group.name, Group);
  Vue.use(Button)
};  

export default YwButton;
